// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://skbigxbkrvsnsxzboorx.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNrYmlneGJrcnZzbnN4emJvb3J4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1MDM0ODAsImV4cCI6MjA3MTA3OTQ4MH0.3XCLQls_YjBkayMfWuRNZMg3vG-D537Tt5nGiRqQVNg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});